import { ShipType } from "./data.model";
import { CourierBusiness } from "./enumeration.model";

// Every FedEx shipment except DOMESTIC asks for the goods value, as in Hub's isCustomDutiesSectionEnabled.
export function fedexAsksShipmentValue(
  courierId: number | undefined,
  shipmentType: ShipType | undefined
): boolean {
  return courierId === CourierBusiness.FEDEX && shipmentType !== "DOMESTIC";
}
